import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/site/content";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-20 md:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-widest text-blue-700 mb-3">
              Common questions
            </div>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight text-gray-900">
              Honest answers, before you commit.
            </h2>
            <p className="mt-5 text-gray-600 leading-relaxed">
              Have a question we haven't covered? Send us a message — a real
              person (not a chatbot) will get back to you within a day.
            </p>
          </div>
          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  className="border-b border-gray-200"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left font-display font-bold text-base md:text-lg text-gray-900 hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-gray-600 leading-relaxed text-sm md:text-base pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
